import { createFileRoute } from '@tanstack/react-router';
import { loadCatalogDetail } from '@/features/catalog/queries';
import { EndpointDetailPage } from '../../../../pages/EndpointDetailPage';

// Dashboard catalog browse (ssr:false, no SEO). Shares the loader shape with the
// marketing /api/:apiId/:endpointId route so the page gets its detail via props;
// the loader simply runs on the client here.
export const Route = createFileRoute('/dashboard/catalog/$apiId/$endpointId')({
  loader: ({ context, params }) => loadCatalogDetail(context.queryClient, params.apiId),
  component: EndpointDetailRoute,
});

function EndpointDetailRoute() {
  const { apiId, endpointId } = Route.useParams();
  const { detail, icon } = Route.useLoaderData();
  return <EndpointDetailPage
      apiId={apiId}
      endpointId={endpointId}
      detail={detail}
      icon={icon}
      presentation="dashboard"
    />;
}
